import {InitalState} from './types';

export const initialState: InitalState = null;
